module.exports = __webpack_public_path__ + "static/media/loading-screen.ffc60325.jpg";